import styled from "styled-components";

import { StyledWrapperProps } from "./types";

export const Wrapper = styled.div<StyledWrapperProps>`
  height: ${({ $height }) => ($height ? `${$height}px` : "100vh")};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.deepSeaDive};
  padding-bottom: env(safe-area-inset-bottom);
`;
